export default {
  meta: {
    title: '数据迁移', // 数据迁移(标准版)
    url: '/system/standardmigration' // 埋点用，记录所属模块
  },
};
